module.exports = __webpack_public_path__ + "static/img/info-culture.a066e14d.png";